import { isWaybetterProduct } from '../../lib/utils';

import { productUrlPrefix } from './url-utils';

const ZEND_DESK_FAQ_URL =
  'https://waybetter.zendesk.com/hc/en-us/categories/360001994313-WayBetter?utm_source=waybetter.app&utm_medium=link&utm_campaign=top_nav';

export const gameFaqUrl = ({ product }) => {
  if (isWaybetterProduct(product)) return ZEND_DESK_FAQ_URL;
  return `${productUrlPrefix(product)}/faq`;
};
